import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetTrendingQuery, useGetPopularQuery } from "../../services/homepage";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { makeStyles } from "@material-ui/core/styles";
import HomeData from "../../Components/HomeData";
import "react-lazy-load-image-component/src/effects/blur.css";
import HomeCarousel from "../../Components/HomeCarousel";
import HomeProductCards from "../../Components/HomeProductCards";
import HelmetComponent from "../../Components/HelmetComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    flexWrap: "nowrap",
    transform: "translateZ(0)",
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
}));

function Home() {
  const { t } = useTranslation();
  const { countryCode } = useSelector((state) => state.auth);
  const trendingData = useGetTrendingQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const popularData = useGetPopularQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const classes = useStyles();
  let adcPosition;
  if (document.body.dir === "rtl") {
    adcPosition = { left: "10px" };
  } else {
    adcPosition = { right: "10px" };
  }

  return (
    <>
      <HelmetComponent title={"Home"} />
      <div className="hp-style">
        <div className="container">
          <HomeCarousel />
        </div>

        <div style={{ padding: "10px" }}></div>
        <div className="container">
          <HomeProductCards
            productData={trendingData.data?.trendings}
            isLoading={trendingData?.isLoading}
            heading={t("trending")}
          />
        </div>

        <div className="container">
          <div className="cardTitle" style={{ padding: "20px 10px 0px 10px" }}>
            Shop by category
          </div>
        </div>
        <div style={{ padding: "10px" }}></div>
        <div className="container">
          <ImageList className={classes.imageList} cols={4}>
            {HomeData?.category_a?.map((item, i) => (
              <ImageListItem className="cardItem" style={{ padding: "10px" }} key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card categories-card" style={{ height: "auto" }}>
                    <img
                      style={{ padding: "0px", borderRadius: "20px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
              </ImageListItem>
            ))}
          </ImageList>
        </div>

        <div style={{ padding: "10px" }}></div>

        <div className="container">
          <ImageList className={classes.imageList} cols={4}>
            {HomeData?.category_b?.map((item, i) => (
              <ImageListItem className="cardItem" style={{ padding: "10px" }} key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "20px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
              </ImageListItem>
            ))}
          </ImageList>
        </div>
        <div style={{ padding: "10px" }}></div>

        <div className="container">
          <HomeProductCards
            productData={popularData.data?.popular}
            isLoading={popularData?.isLoading}
            heading={t("popular")}
          />
        </div>

        <div style={{ padding: "10px" }}></div>

        <div className="container">
          <ImageList className={classes.imageList} cols={4}>
            {HomeData?.fashion?.map((item, i) => (
              <ImageListItem className="cardItem" key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "20px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
              </ImageListItem>
            ))}
          </ImageList>
        </div>
        <div style={{ padding: "20px" }}></div>
      </div>
    </>
  );
}

export default Home;
